import React from 'react';
import InputGroup from '../../InputGroup';

import { Field } from 'redux-form';

const formatExpDate = (value, unParsedPrevValue) => {
    let newValue = value;
    if (value && value.length > 1) {
        newValue = `${value.slice(0, 2)}`;
        if (value.length === 2 && unParsedPrevValue && unParsedPrevValue.endsWith(' / '))
            return newValue;

        newValue += ' / ' + value.slice(2);
    }
    return newValue;
};

const parseExpDate = value => {
    const digitsOnly = value.replace(/\D/g, '');
    return digitsOnly == null || digitsOnly === '' ? null : digitsOnly.replace(/\D/g, '');
};

const setCarotPosition = ev => {
    setTimeout(() => {
        var target = ev.target;
        var value = target.value;
        target.selectionStart = target.selectionEnd = value.length;
    }, 50);
};

const ExpirationDateInput = () => (
    <Field
        name="expDate"
        component={InputGroup}
        label="Exp. date"
        normalize={(value, unParsedPrevValue) => formatExpDate(value, unParsedPrevValue)}
        parse={value => parseExpDate(value)}
        onChange={ev => setCarotPosition(ev)}
        maxLength={7}
        placeholder="Exp. Date"
        type="tel"
        autocomplete="cc-exp"
    />
);

export default ExpirationDateInput;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/ExpirationDateInput.jsx